export const HEADERS_PANEL_STORAGE_KEY = 'httpHeadersPanelExpanded';

export const readHeadersPanelExpanded = (): boolean =>
    localStorage.getItem(HEADERS_PANEL_STORAGE_KEY) !== 'false';

export const writeHeadersPanelExpanded = (expanded: boolean): void => {
    localStorage.setItem(HEADERS_PANEL_STORAGE_KEY, String(expanded));
};
